// extracted by mini-css-extract-plugin
export default {"modal":"Lca-z","modalContent":"Mca-z","footer":"Nca-z","cancelBtn":"Oca-z","disabled":"Pca-z","formWrapper":"Qca-z","fade":"Rca-z","fade-in":"Sca-z","iframe":"Tca-z"};